import { useEffect, useState } from "react";
import { AlgoliaFilter } from "lib/algolia";
import { SearchClient } from "algoliasearch/dist/algoliasearch-lite";

interface SearchClientInformation {
  client: SearchClient | null;
  loading: boolean;
}

/**
 * @deprecated
 */
const useCreateAlgoliaClient = (): SearchClientInformation => {
  const [searchClient, setSearchClient] = useState<SearchClient | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    let isActive = true;
    if (!searchClient) {
      setLoading(true);
      void AlgoliaFilter.getClient().then((data) => {
        if (isActive) {
          setSearchClient(data);
          setLoading(false);
        }
      });
    }
    return () => {
      isActive = false;
      setLoading(false);
    };
  }, [searchClient]);

  return {
    client: searchClient,
    loading,
  };
};

export default useCreateAlgoliaClient;
